import * as moment from 'moment';

import type { Category } from './common';

export type SnapshotFilters = {
  labels?: number[],
  start: Date,
  end: Date,
  category?: Category;
  projectId?: string;
  teamId?: number[] | 'null',
};

/**
 * Applies common defaults to date filters for the snapshots.  It defaults to values before now and after 30 days ago,
 * only updating values that are not present.
 */
export function applyFilterDefaults(filters: Partial<SnapshotFilters>): SnapshotFilters {
  return {
    ...filters,
    start: filters.start ?? moment().subtract(30, 'days').toDate(),
    end: filters.end ?? moment().endOf('day').toDate(),
  };
}
